/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Submit_DescInputs */

const en_directory_launch_submit_desc = /** @type {(inputs: Directory_Launch_Submit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share an AI tool for review and discovery.`)
};

const zh_directory_launch_submit_desc = /** @type {(inputs: Directory_Launch_Submit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交一个 AI 工具，审核后进入目录发现流。`)
};

/**
* | output |
* | --- |
* | "Share an AI tool for review and discovery." |
*
* @param {Directory_Launch_Submit_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_submit_desc = /** @type {((inputs?: Directory_Launch_Submit_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Submit_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_submit_desc(inputs)
	return zh_directory_launch_submit_desc(inputs)
});
export { directory_launch_submit_desc as "directory.launch.submit_desc" }